var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.67 20 4.86-4.821V8.82L6.67 4 4 6.648 9.397 12 4 17.352 6.67 20ZM20 17.352l-5.617-5.571.221.219L20 6.648 17.331 4l-4.86 4.821v6.358L17.33 20l2.67-2.648Z",
    fill: "#475467"
  })));
};
export default SvgClose;